import React from 'react';
import ReactDOM from 'react-dom';
import {QueryClient, QueryClientProvider} from 'react-query';

import UserRegistration from './pages/Registration/UserRegistration';

const context = document.getElementById('user-registration-context').value;
const preselectedGroupId = document.getElementById('preselected-group-id').value;
const preselectedSubscriptionItemId = document.getElementById('preselected-subscription-item-id').value;
const purchasingGroupId = document.getElementById('purchasing-group-id').value;
const contactId = document.getElementById('contact-id').value;
const portalCode = document.getElementById('portal-code').value;
const defaultFrequency = document.getElementById('defaultFrequency').value;
const furtherOffersDefaultValue = document.getElementById('furtherOffersDefaultValue').value;

const query = new URLSearchParams(location.search);
const promoCode = query.get('promoCode');




const resolveRegistrationContext = (context) => {
    switch (context) {
        case 'ADD_CONTACT':
            return context;
        default:
            return 'PUBLIC_REGISTRATION';
    }
}

const queryClient = new QueryClient();

ReactDOM.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <UserRegistration
                context={resolveRegistrationContext(context)}
                preselectedGroupId={preselectedGroupId}
                preselectedSubscriptionItemId={preselectedSubscriptionItemId ? JSON.parse(preselectedSubscriptionItemId) : null}
                purchasingGroupId={purchasingGroupId}
                contactId={contactId}
                portalCode = {portalCode}
                defaultFrequency = {defaultFrequency}
                furtherOffersDefaultValue = {furtherOffersDefaultValue}
                promoCode = {promoCode}
            />
        </QueryClientProvider>
    </React.StrictMode>,
    document.getElementById('react-user-registration')
);
